import {FC} from 'react'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {Link} from 'react-router-dom'

type Props = {
  data: any
}
const EvaluationReportActionsCell: FC<Props> = ({data}) => {
  console.log('data EvaluationReportActionsCell', data)
  return (
    <>
      <div className='d-flex flex-column align-items-md-center'>
        <Link
          to={`/editevaluationreport/${data.uuid}`}
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
        >
          <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
        </Link>
      </div>
    </>
  )
}

export {EvaluationReportActionsCell}
